import type { QueueItem } from "@/lib/review/queue"

/**
 * Filter the review queue by a free-text query, matched case-insensitively
 * against the key, the EN source, and the current translation. An empty or
 * whitespace-only query returns the list unchanged (preserving order).
 */
export function filterQueue(items: QueueItem[], query: string): QueueItem[] {
  const q = query.trim().toLowerCase()
  if (!q) return items
  return items.filter(
    (i) =>
      i.key.toLowerCase().includes(q) ||
      i.enValue.toLowerCase().includes(q) ||
      i.targetValue.toLowerCase().includes(q)
  )
}
